import { environment } from '../../environments/environment';

export function isApiRequest(url: string): boolean {
  const target = new URL(url, window.location.origin);
  const apiOrigin = new URL(
    `${environment.api.protocol}://${environment.api.host}:${environment.api.port}`,
  ).origin;
  return (
    target.pathname.startsWith('/api/') &&
    (target.origin === apiOrigin ||
      (url.startsWith('/api/') && target.origin === window.location.origin))
  );
}

export function isAuthSessionRequest(url: string): boolean {
  const path = new URL(url, window.location.origin).pathname;
  return /^\/api\/v1\/auth\/(login|demo-login|register|google|refresh|logout|account-discovery|forgot-password|reset-password)(\/|$)/.test(
    path,
  );
}
